import React from "react"
import { Container, Row, Col } from "react-bootstrap"
import { Link } from "gatsby"
import "./assets/styles/_index.scss"
import GGFXImage from "../GGFX/GGFXImage"
const { ContentModule } = require("@starberry/gatsby-theme-utils/Modules/ContentModule")
const { CTALink } = require("@starberry/gatsby-theme-utils/Modules/CTALinkModule")


const AboutSpaces = (props) => {
    return (
        <section className="about-spaces-wrapper">
            <Container>
                <Row className="d-flex align-items-center">
                    <Col xl={5} className="order-xl-1 order-2">
                        <div className="about-spaces-img-card-wrapper">
                            <div className="about-spaces-img-grid-first">
                                {props.add_image && props.add_image.slice(0, 2).map((item, index) => {
                                    var image_name = index === 0 ? "page.image_content_section.image_one" : "page.image_content_section.image_two"
                                    return (
                                        <div className={`about-spaces-img-wrapper img-wrapper grid-img-${index + 1}`}>
                                            <GGFXImage ImageSrc={item} altText={`${props?.image?.alternativeText ? props?.image?.alternativeText : ""} banner`} imagetransforms={props.imagetransforms} renderer="srcSet" imagename={image_name} strapiID={props?.id} className="img-fluid" />
                                        </div>
                                    )
                                })}
                            </div>
                            <div className="about-spaces-img-grid-second">
                                {props.add_image && props.add_image.slice(2, 5).map((item, index) => {
                                    var image_name = index === 0 ? "page.image_content_section.image_two" : "page.image_content_section.image_one"
                                    return (
                                        <div className={`about-spaces-img-wrapper img-wrapper grid-img-${index + 3}`}>
                                            <GGFXImage ImageSrc={item} altText={`${props?.image?.alternativeText ? props?.image?.alternativeText : ""} banner`} imagetransforms={props.imagetransforms} renderer="srcSet" imagename={image_name} strapiID={props?.id} className="img-fluid" />
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </Col>
                    <Col xl={1} className="order-xl-2"></Col>
                    <Col xl={6} className="order-xl-3 order-1">
                        {props?.description ? <ContentModule Content={props.description?.data?.description} /> : ""}
                        {props?.cta_1 && <CTALink class="button button-outline" link={props.cta_1} title={props.cta_1_title} target_window={props.cta_1.target_window} />}
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default AboutSpaces